





import {Vue, Component, Model, Emit} from 'vue-property-decorator';

@Component
export default class PageFormDate extends Vue {
  @Model('change', {
    type: String
  })
  inComingDate!: string;

  @Emit('change')
  private dateChange(e: Event) {
    return (e.target as HTMLSelectElement).value;
  }
}
